import { useI18n } from 'vue-i18n'

export const translations = {
  'pt-br': {
    BackupLoginAlertTitle: 'Recomendamos reconfigurar sua autenticação 2FA',
    BackupLoginAlertBody: 'Você entrou com um código de backup. Acesse Meu Perfil e reconfigure o 2FA para manter sua conta segura.'
  },
  'en-US': {
    BackupLoginAlertTitle: 'We recommend reconfiguring your 2FA authentication',
    BackupLoginAlertBody: 'You signed in with a backup code. Go to My Profile and reconfigure 2FA to keep your account secure.'
  }
}

export const useTwoFactorPostLoginNoticeTranslation = () => useI18n({ messages: translations })
